import React from 'react';
import { Hero } from '../sections/Hero';
import { WhoStrip } from '../sections/WhoStrip';
import { CredibilityStrip } from '../sections/CredibilityStrip';
import { ProblemRecognition } from '../sections/ProblemRecognition';
import { FrameworkOverview } from '../sections/FrameworkOverview';
import { LeadMagnet } from '../sections/LeadMagnet';
import { WhyMGS } from '../sections/WhyMGS';
import { ResourcesPreview } from '../sections/ResourcesPreview';
import { InsightsPreview } from '../sections/InsightsPreview';
import { FieldNotes } from '../sections/FieldNotes';
import { ContactQuestion } from '../sections/ContactQuestion';
import { FAQ } from '../sections/FAQ';
import { FinalCTA } from '../sections/FinalCTA';
interface HomeProps {
  onDownload: (title?: string) => void;
}
export function Home({
  onDownload
}: HomeProps) {
  return <>
      <Hero onDownload={() => onDownload()} data-id="element-348" />
      <WhoStrip data-id="element-349" />
      <CredibilityStrip data-id="element-350" />
      <ProblemRecognition data-id="element-351" />
      <FrameworkOverview data-id="element-352" />
      <LeadMagnet data-id="element-353" />
      <WhyMGS onDownload={() => onDownload()} data-id="element-354" />
      <ResourcesPreview onOpenResource={title => onDownload(title)} data-id="element-355" />
      <InsightsPreview data-id="element-356" />
      <FieldNotes data-id="element-357" />
      <ContactQuestion onDownload={() => onDownload()} data-id="element-358" />
      <FAQ onDownload={() => onDownload()} data-id="element-359" />
      <FinalCTA onDownload={() => onDownload()} data-id="element-360" />
    </>;
}